import { useApp } from '../context.js';
import { Star } from '../icons.jsx';
import { wantToTryState } from '../lib/visits.js';

export default function RandomPickerModal() {
    const { closeRandomPicker, isSpinning, openInMaps, pickerRestaurant, showRandomPicker, spinAgain } = useApp();
    if (!showRandomPicker) return null;
    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50" onClick={() => !isSpinning && closeRandomPicker()}>
            <div className="bg-white rounded-3xl p-6 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">
                        🎲 Where should we eat?
                    </h2>
                    <p className="text-sm text-gray-500 mb-6">
                        {isSpinning ? 'Spinning...' : 'Your destination awaits!'}
                    </p>

                    <div className={`bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-6 mb-6 ${!isSpinning && pickerRestaurant ? 'celebrate' : ''}`}>
                        {pickerRestaurant ? (
                            <div className={isSpinning ? 'animate-pulse' : ''}>
                                <div className="text-3xl mb-2">🍽️</div>
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    {pickerRestaurant.name}
                                </h3>
                                {!isSpinning && wantToTryState(pickerRestaurant) === 'both' && (
                                    <p className="text-sm font-semibold text-pink-600 mb-2">You both wanted to try this one! 💛💖</p>
                                )}
                                {typeof pickerRestaurant.rating === 'number' && (
                                    <div className="inline-flex items-center gap-1 bg-white px-3 py-1 rounded-full shadow-sm">
                                        <Star size={14} className="text-yellow-500 fill-yellow-500" />
                                        <span className="text-sm font-semibold text-gray-700">{pickerRestaurant.rating}/10</span>
                                    </div>
                                )}
                                {pickerRestaurant.address && !isSpinning && (
                                    <p className="text-sm text-gray-600 mt-3">{pickerRestaurant.address}</p>
                                )}
                            </div>
                        ) : (
                            <div className="text-gray-400">
                                <div className="text-4xl mb-2">🎰</div>
                                <p>Ready to spin!</p>
                            </div>
                        )}
                    </div>

                    {!isSpinning && pickerRestaurant && (
                        <div className="flex gap-2">
                            <button
                                onClick={spinAgain}
                                className="flex-1 bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button"
                            >
                                🎲 Spin Again
                            </button>
                            <button
                                onClick={() => {
                                    closeRandomPicker();
                                    if (pickerRestaurant.address) {
                                        openInMaps(pickerRestaurant.address);
                                    }
                                }}
                                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-3 rounded-xl font-semibold apple-button"
                            >
                                ✓ Let's Go!
                            </button>
                        </div>
                    )}

                    {!isSpinning && !pickerRestaurant && (
                        <button
                            onClick={() => closeRandomPicker()}
                            className="w-full bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button"
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
